import React from "react";
import { Menu } from "antd";
import "./navbar.css";
import {
  EnvironmentOutlined,
  FundProjectionScreenOutlined,
  ClockCircleOutlined,
  PieChartOutlined,
  HistoryOutlined,
  ContainerOutlined,
  DashboardOutlined,
  HeatMapOutlined,
  IssuesCloseOutlined,
  NotificationOutlined,
  AimOutlined,
  AudioMutedOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import { DevDummyPermissionHelper, DummyPermissionCancellationsreasonsHelper, DummyPermissionHelper, DummyPermissionHelperTriggers, DummyPermissionHelperUnRegisterRider, DummyPermissionHelperWork } from "../../utils/Helpers";
import { userhasPermissionHelper } from "../../utils/Helpers";
import { connect } from "react-redux";
import { PERMISSION_CONSTANT } from "../../utils/constants/app";
function getItem(label, key, icon, children, type) {
  return {key, icon, children, label, type,};
}

const Navbar = (props) => {
  let items = [];

  // Dashboard permission
  if(
    DummyPermissionHelper(props?.emailUser?.email) ||
    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RS_DASHBOARD) || 
    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_CURRENT_ORDERS) 
  ){
    let dashboard_sub = [];
    // if(DummyPermissionHelper(props?.emailUser?.email))
      // dashboard_sub.push(getItem(<NavLink key="2.1" exact="true" to="/dashboardnew">Dashboard New</NavLink>, "6.0"));
    if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RS_DASHBOARD)){
      dashboard_sub.push(getItem(<NavLink key="1.1" exact="true" to="/dashboard">Dashboard</NavLink>, "1.1"));
    }
    if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_CURRENT_ORDERS)){
      dashboard_sub.push(getItem(<NavLink key="1.2" exact="true" to="/dashboard/riderorder">Rider Current Order</NavLink>,"1.2"));
    }
    if(DummyPermissionHelper(props?.emailUser?.email)){
      dashboard_sub.push(getItem(<NavLink key="1.3" exact="true" to="/dashboard/metricsdashboard">Metrics Dashboard</NavLink>, "1.3"));
    }
    // if(DummyPermissionHelper(props?.emailUser?.email)){
      dashboard_sub.push(getItem("Shifts Fill Rates", "sub1.4", '',[
        getItem(<NavLink key="1.4.1" exact="true" to="/dashboard/shifts">Shift level view</NavLink>, "1.4.1"),
        getItem(<NavLink key="1.4.2" exact="true" to="/dashboard/mart">Mart level view</NavLink>, "1.4.2")
      ]))
    // }
    // if(DummyPermissionHelper(props?.emailUser?.email)){
      dashboard_sub.push(getItem(<NavLink key="1.5" exact="true" to="/dashboard/mart-health">Mart Health Dashboard</NavLink>, "1.5"));
    // }
    items.push(
      getItem("Dashboard", "sub1.0", <FundProjectionScreenOutlined />,dashboard_sub)
    );
  }

  // order permission
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ORDERS)){
    items.push(
      getItem(<NavLink key="2" exact="true" to="/overview">Overview</NavLink>,"2",<PieChartOutlined />),
    );
  }

  // batch permission
  if(
    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_BATCH_RIDERS) || 
    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_DEFAULT_CONFIG) ||
    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_WALLET_STACKING) 
  ){
    let dashboard_sub = [];
    if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_BATCH_RIDERS))
      dashboard_sub.push(getItem(<NavLink key="3.1" exact="true" to="/batch">Batch Riders</NavLink>, "3.1"));
    if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_DEFAULT_CONFIG))
      dashboard_sub.push(getItem(<NavLink key="3.2" exact="true" to="/batch/defaultconfiguration">Default Configuration</NavLink>, "3.2"));
    if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_WALLET_STACKING))
      dashboard_sub.push(getItem(<NavLink key="3.3" exact="true" to="/batch/walletstacking">Wallet & Stacking</NavLink>,"3.3"));

    items.push(
      getItem(
        "Batch",
        "sub3.0",
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 1L1 4.25L7.5 7.5L14 4.25L7.5 1Z"
            stroke="#282828"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1 10.75L7.5 14L14 10.75"
            stroke="#282828"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1 7.5L7.5 10.75L14 7.5"
            stroke="#282828"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>,
        dashboard_sub
      )
    );
  }

  // zone permission
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ZONES)){
    items.push(getItem(<NavLink key="4" exact="true" to="/zones">Zones</NavLink>, "4", <EnvironmentOutlined />));
  }

  // rider permission
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDERS)){
    items.push(
      getItem(
        <NavLink className="nav-link" key="5" exact="true" to="/rider">
          Riders
        </NavLink>,
        "5",
        <svg
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.3333 2.73171C11.0667 2.73171 11.6667 2.11707 11.6667 1.36585C11.6667 0.614634 11.0667 0 10.3333 0C9.6 0 9 0.614634 9 1.36585C9 2.11707 9.6 2.73171 10.3333 2.73171ZM3.33333 7.17073C1.46667 7.17073 0 8.67317 0 10.5854C0 12.4976 1.46667 14 3.33333 14C5.2 14 6.66667 12.4976 6.66667 10.5854C6.66667 8.67317 5.2 7.17073 3.33333 7.17073ZM3.33333 12.9756C2.06667 12.9756 1 11.8829 1 10.5854C1 9.2878 2.06667 8.19512 3.33333 8.19512C4.6 8.19512 5.66667 9.2878 5.66667 10.5854C5.66667 11.8829 4.6 12.9756 3.33333 12.9756ZM7.2 6.14634L8.8 4.50732L9.33333 5.05366C10.2 5.94146 11.3333 6.4878 12.7333 6.4878V5.12195C11.7333 5.12195 10.9333 4.71219 10.3333 4.09756L9.06667 2.8C8.73333 2.52683 8.4 2.39024 8 2.39024C7.6 2.39024 7.26667 2.52683 7.06667 2.8L5.2 4.71219C4.93333 4.98537 4.8 5.32683 4.8 5.66829C4.8 6.07805 4.93333 6.41951 5.2 6.62439L7.33333 8.53659V11.9512H8.66667V7.71707L7.2 6.14634ZM12.6667 7.17073C10.8 7.17073 9.33333 8.67317 9.33333 10.5854C9.33333 12.4976 10.8 14 12.6667 14C14.5333 14 16 12.4976 16 10.5854C16 8.67317 14.5333 7.17073 12.6667 7.17073ZM12.6667 12.9756C11.4 12.9756 10.3333 11.8829 10.3333 10.5854C10.3333 9.2878 11.4 8.19512 12.6667 8.19512C13.9333 8.19512 15 9.2878 15 10.5854C15 11.8829 13.9333 12.9756 12.6667 12.9756Z"
            fill="#282828"
          />
        </svg>
      )
    );
  }

  // un register rider permission
  // if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDERS)){
  if(DummyPermissionHelperUnRegisterRider(props?.emailUser?.email)){
    items.push(
      getItem(
        <NavLink className="nav-link" key="17" exact="true" to="/un-register/rider">
          Un-register Riders
        </NavLink>,
        "17",
        <svg
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.3333 2.73171C11.0667 2.73171 11.6667 2.11707 11.6667 1.36585C11.6667 0.614634 11.0667 0 10.3333 0C9.6 0 9 0.614634 9 1.36585C9 2.11707 9.6 2.73171 10.3333 2.73171ZM3.33333 7.17073C1.46667 7.17073 0 8.67317 0 10.5854C0 12.4976 1.46667 14 3.33333 14C5.2 14 6.66667 12.4976 6.66667 10.5854C6.66667 8.67317 5.2 7.17073 3.33333 7.17073ZM3.33333 12.9756C2.06667 12.9756 1 11.8829 1 10.5854C1 9.2878 2.06667 8.19512 3.33333 8.19512C4.6 8.19512 5.66667 9.2878 5.66667 10.5854C5.66667 11.8829 4.6 12.9756 3.33333 12.9756ZM7.2 6.14634L8.8 4.50732L9.33333 5.05366C10.2 5.94146 11.3333 6.4878 12.7333 6.4878V5.12195C11.7333 5.12195 10.9333 4.71219 10.3333 4.09756L9.06667 2.8C8.73333 2.52683 8.4 2.39024 8 2.39024C7.6 2.39024 7.26667 2.52683 7.06667 2.8L5.2 4.71219C4.93333 4.98537 4.8 5.32683 4.8 5.66829C4.8 6.07805 4.93333 6.41951 5.2 6.62439L7.33333 8.53659V11.9512H8.66667V7.71707L7.2 6.14634ZM12.6667 7.17073C10.8 7.17073 9.33333 8.67317 9.33333 10.5854C9.33333 12.4976 10.8 14 12.6667 14C14.5333 14 16 12.4976 16 10.5854C16 8.67317 14.5333 7.17073 12.6667 7.17073ZM12.6667 12.9756C11.4 12.9756 10.3333 11.8829 10.3333 10.5854C10.3333 9.2878 11.4 8.19512 12.6667 8.19512C13.9333 8.19512 15 9.2878 15 10.5854C15 11.8829 13.9333 12.9756 12.6667 12.9756Z"
            fill="#282828"
          />
        </svg>
      )
    );
  }

  // Shifts permission
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_SHIFTS)){
    items.push(getItem(<NavLink key="6" exact="true" to="/shifts">Shifts</NavLink>, "6", <ClockCircleOutlined />));
  }

  // Break permission
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_BREAK)){
    items.push(getItem(<NavLink key="7" exact="true" to="/break">Break</NavLink>, "7", <HeatMapOutlined />));
  }

  items.push(
    getItem("Compliance", "sub7.0", <HeatMapOutlined />, [
      getItem(
        <NavLink key="7.1" exact="true" to="/wallet/compliance-history">
          Wallet Compliance
        </NavLink>,
        "7.1"
      ),
      getItem(
        <NavLink key="7.2" exact="true" to="/radius/compliance-history">
          Radius Compliance
        </NavLink>,
        "7.2"
      ),
    ])
  );

  // Dispatcher Notes Management permission
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.CREATE_ORDER_DISPATCHER_NOTES)){
    items.push(getItem(<NavLink key="8" exact="true" to="/dispatchernote">Dispatcher Notes</NavLink>, "8", <ContainerOutlined />));
  }

  // Cancellations Reasons Management permission
  if(DummyPermissionCancellationsreasonsHelper(props?.emailUser?.email)){
    items.push(getItem(<NavLink key="15" exact="true" to="/cancellationsreasons">Cancellations Reasons</NavLink>, "15", <AudioMutedOutlined />));
  }

  // items.push(
  //   getItem(
  //     <NavLink className="nav-link" key="15" exact="true" to="/cancellationsreasons">Cancellations Reasons</NavLink>,
  //     "15",
  //     <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" >
  //       <path
  //         d="M10.3333 2.73171C11.0667 2.73171 11.6667 2.11707 11.6667 1.36585C11.6667 0.614634 11.0667 0 10.3333 0C9.6 0 9 0.614634 9 1.36585C9 2.11707 9.6 2.73171 10.3333 2.73171ZM3.33333 7.17073C1.46667 7.17073 0 8.67317 0 10.5854C0 12.4976 1.46667 14 3.33333 14C5.2 14 6.66667 12.4976 6.66667 10.5854C6.66667 8.67317 5.2 7.17073 3.33333 7.17073ZM3.33333 12.9756C2.06667 12.9756 1 11.8829 1 10.5854C1 9.2878 2.06667 8.19512 3.33333 8.19512C4.6 8.19512 5.66667 9.2878 5.66667 10.5854C5.66667 11.8829 4.6 12.9756 3.33333 12.9756ZM7.2 6.14634L8.8 4.50732L9.33333 5.05366C10.2 5.94146 11.3333 6.4878 12.7333 6.4878V5.12195C11.7333 5.12195 10.9333 4.71219 10.3333 4.09756L9.06667 2.8C8.73333 2.52683 8.4 2.39024 8 2.39024C7.6 2.39024 7.26667 2.52683 7.06667 2.8L5.2 4.71219C4.93333 4.98537 4.8 5.32683 4.8 5.66829C4.8 6.07805 4.93333 6.41951 5.2 6.62439L7.33333 8.53659V11.9512H8.66667V7.71707L7.2 6.14634ZM12.6667 7.17073C10.8 7.17073 9.33333 8.67317 9.33333 10.5854C9.33333 12.4976 10.8 14 12.6667 14C14.5333 14 16 12.4976 16 10.5854C16 8.67317 14.5333 7.17073 12.6667 7.17073ZM12.6667 12.9756C11.4 12.9756 10.3333 11.8829 10.3333 10.5854C10.3333 9.2878 11.4 8.19512 12.6667 8.19512C13.9333 8.19512 15 9.2878 15 10.5854C15 11.8829 13.9333 12.9756 12.6667 12.9756Z"
  //         fill="#282828"
  //       />
  //     </svg>
  //   )
  // );

  
  // Rider Location permission
  if(
    // DummyPermissionHelper(props?.emailUser?.email) || 
    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_LOCATION)
  ){
    items.push(getItem(<NavLink key="9" exact="true" to="/riderlocation">Rider Location</NavLink>,"9",<AimOutlined />));
  }

  // Notification permission
  if(
    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_NOTIFICATION)
  ){
    let dashboard_sub = [];
    // if(DummyPermissionHelper(props?.emailUser?.email))
      dashboard_sub.push(getItem(<NavLink key="10.1" exact="true" to="/notification">Notification</NavLink>, "10.1"));
    // if(DummyPermissionHelper(props?.emailUser?.email))
      dashboard_sub.push(getItem(<NavLink key="10.2" exact="true" to="/categories">Categories</NavLink>,"10.2"));
    items.push(
      getItem("Notifications", "sub10.0", <NotificationOutlined />,dashboard_sub)
    );
  }

  // Cancelled Orders permission
  // DummyPermissionHelper(props?.emailUser?.email)
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_CANCELLED_ORDERS_DASHBOARD)){
    items.push(getItem(<NavLink key="11" exact="true" to="/cancelledorder">Cancelled Orders</NavLink>, "11", <HistoryOutlined />));
  }

  // Issue Management permission
  let issues_sub = [];
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_OPEN_ISSUES)){
    issues_sub.push(getItem(<NavLink key="12.1" exact="true" to="/openissues">Open Issues</NavLink>, "12.1"));
  }
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_PICKED_OPEN_ISSUES)){
    issues_sub.push(getItem(<NavLink key="12.2" exact="true" to="/pickedissues">Picked Open Issues</NavLink>, "12.2"));
  }
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_MY_OPEN_ISSUES)){
    issues_sub.push(getItem(<NavLink key="12.3" exact="true" to="/myissues">My Open Issues</NavLink>, "12.3"));
  }
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ISSUES_HISTORY)){
    issues_sub.push(getItem(<NavLink key="12.3" exact="true" to="/historyissues">Issues History</NavLink>, "12.4"));
  }
  if(
    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_OPEN_ISSUES) || 
    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_PICKED_OPEN_ISSUES) || 
    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_MY_OPEN_ISSUES) || 
    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ISSUES_HISTORY)
  ) {
    items.push(
      getItem("Issues", "sub12.0", <IssuesCloseOutlined />, issues_sub)
    );
  }
  // if(
  //     DummyPermissionHelper(props?.emailUser?.email)
  //   ){
  // }
  
  // Performance permission
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_PERFORMANCE_KPI_DASHBOARD)){
    items.push(getItem(<NavLink key="13" exact="true" to="/performance">Performance</NavLink>, "13", <DashboardOutlined />));
  }
  
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_PICKER_PACKER)){
    items.push(
      getItem(
        <NavLink className="nav-link" key="14" exact="true" to="/pickerpacker">
          Picker Packer
        </NavLink>,
        "14",
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" >
          <path
            d="M10.3333 2.73171C11.0667 2.73171 11.6667 2.11707 11.6667 1.36585C11.6667 0.614634 11.0667 0 10.3333 0C9.6 0 9 0.614634 9 1.36585C9 2.11707 9.6 2.73171 10.3333 2.73171ZM3.33333 7.17073C1.46667 7.17073 0 8.67317 0 10.5854C0 12.4976 1.46667 14 3.33333 14C5.2 14 6.66667 12.4976 6.66667 10.5854C6.66667 8.67317 5.2 7.17073 3.33333 7.17073ZM3.33333 12.9756C2.06667 12.9756 1 11.8829 1 10.5854C1 9.2878 2.06667 8.19512 3.33333 8.19512C4.6 8.19512 5.66667 9.2878 5.66667 10.5854C5.66667 11.8829 4.6 12.9756 3.33333 12.9756ZM7.2 6.14634L8.8 4.50732L9.33333 5.05366C10.2 5.94146 11.3333 6.4878 12.7333 6.4878V5.12195C11.7333 5.12195 10.9333 4.71219 10.3333 4.09756L9.06667 2.8C8.73333 2.52683 8.4 2.39024 8 2.39024C7.6 2.39024 7.26667 2.52683 7.06667 2.8L5.2 4.71219C4.93333 4.98537 4.8 5.32683 4.8 5.66829C4.8 6.07805 4.93333 6.41951 5.2 6.62439L7.33333 8.53659V11.9512H8.66667V7.71707L7.2 6.14634ZM12.6667 7.17073C10.8 7.17073 9.33333 8.67317 9.33333 10.5854C9.33333 12.4976 10.8 14 12.6667 14C14.5333 14 16 12.4976 16 10.5854C16 8.67317 14.5333 7.17073 12.6667 7.17073ZM12.6667 12.9756C11.4 12.9756 10.3333 11.8829 10.3333 10.5854C10.3333 9.2878 11.4 8.19512 12.6667 8.19512C13.9333 8.19512 15 9.2878 15 10.5854C15 11.8829 13.9333 12.9756 12.6667 12.9756Z"
            fill="#282828"
          />
        </svg>
      )
    );
  }
  
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_TRIGGERS)){
    items.push(    
      getItem(
        <NavLink className="nav-link" key="16" exact="true" to="/triggers">Triggers</NavLink>,
        "16",
        <AimOutlined />
      ),
    );
  }

  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_WORK)){
    items.push(
      getItem("Packmate", "sub18.0", <ContainerOutlined />, [
        getItem(
          <NavLink key="18.1" exact="true" to="/works">
            Works
          </NavLink>,
          "18.1"
        ),
        getItem(
          <NavLink key="18.2" exact="true" to="/works/approval-history">
            Approval History
          </NavLink>,
          "18.2"
        ),
      ])
    );
  }

  // if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_WORK)){
    items.push(    
      getItem(
        <NavLink className="nav-link" key="19" exact="true" to="/item-level-inventory">Item Level Inventory</NavLink>,
        "19",
        <ContainerOutlined />
      ),
    );
  // }

  // items.push(    
  // getItem(
  //   <NavLink key="6" exact="true" to="/wallet/issues">
  //     Wallet Issues
  //   </NavLink>,
  //   "6",
  //   <WalletOutlined />
  // ),
  // );
  

  // console.log("email", props.emailUser.email)
  // console.log("email",userEmailAllow(props.emailUser.email) )

  // CMS (view for all; edit is permission-based inside page)
  if(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RIDER_TERMS_AND_CONDITIONS)){
    items.push(
    getItem(
      <NavLink className="nav-link" key="20" exact="true" to="/cms">
        CMS
      </NavLink>,
      "20",
      <FileTextOutlined />
    )
  );
}

  return (
    <div className="aside-navbar">
      <Menu
        mode="inline"
        items={items}
        // defaultSelectedKeys={["1"]}
        // defaultOpenKeys={["sub1"]}
        // theme="dark"
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    emailUser: state.authReducer.user,
    permissions: state.PermissionReducer.permissions,
  };
};

export default connect(mapStateToProps,)(Navbar);
